import { render, staticRenderFns } from "./FirstStart.vue?vue&type=template&id=539a470a&scoped=true"
import script from "./FirstStart.vue?vue&type=script&lang=ts"
export * from "./FirstStart.vue?vue&type=script&lang=ts"
import style0 from "./FirstStart.vue?vue&type=style&index=0&id=539a470a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539a470a",
  null
  
)

export default component.exports